import Vue from 'vue';
Vue.component('selfButton', ()=>import('components/self-button'))
Vue.component('goodsPrice', ()=>import('components/goods-price'))
Vue.component('titleHeader', ()=>import('components/title-header'))